/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { MileageReimbursementRate } from '../models/MileageReimbursementRate';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class MileageReimbursementRateService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns MileageReimbursementRate
     * @throws ApiError
     */
    public mileageReimbursementRateGetAll(): Observable<Array<MileageReimbursementRate>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/mileagereimbursementrates',
        });
    }
    /**
     * @param countryCode
     * @param date
     * @returns MileageReimbursementRate
     * @throws ApiError
     */
    public mileageReimbursementRateGet(
        countryCode?: string | null,
        date?: string,
    ): Observable<MileageReimbursementRate> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/mileagereimbursementrates/currentRate',
            query: {
                'countryCode': countryCode,
                'date': date,
            },
        });
    }
}
